<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <ap-field
    [title]="'entityType.name' | translate"
    [required]="true"
    [error]="nameField.touched && !!nameField.errors">
    <input appkit-field formControlName="name" [maxLength]="maxNameLength" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: maxNameLength - nameField.value.length }
      }}
    </div>
    @if (nameField.touched && nameField.errors?.['required']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.required' | translate }}
      </div>
    }
    @if (nameField.touched && nameField.errors?.['pattern']) {
      <div class="ap-field-validation-error">
        {{ 'formValidations.lettersRequired' | translate }}
      </div>
    }
  </ap-field>

  <gstar-countries-combobox
    #resJur
    [title]="'entityType.country' | translate"
    [value]="countryValue"
    [required]="!isDefault"
    [disabled]="isEdit && isDefault"
    (selectCountry)="countrySelect($event)"
    (clearCountry)="clearCountry()" />
  <ap-checkbox formControlName="isActive" class="mt-2">
    {{ 'entityType.isActive' | translate }}
  </ap-checkbox>
  @if (countryValue && !isDefault) {
    <gstar-investment-jurisdiction-combobox
      #investmentJurisdictionComp
      [title]="'entityType.country' | translate"
      [isEntityTypeSection]="true"
      [disabled]="isEdit && isDefault"
      (selectInvestmentJurisdiction)="invJurisdictionSelect($event)" />
    @for (
      jurisdiction of entityTypeInvestmentJurisdiction;
      track jurisdiction.investmentJurisdiction?.investmentJurisdictionId
    ) {
      <gstar-selected-investment-jurisdiction-component
        [invJurisdiction]="jurisdiction.investmentJurisdiction"
        [targetEntityType]="jurisdiction.targetEntityType"
        [index]="$index"
        (targetEntityChangeOutput)="handleTargetEntityChange($index, $event)"
        (removeInvestmentJurisdiction)="onRemoveJurisdiction($event)">
      </gstar-selected-investment-jurisdiction-component>
    }
  }
</form>
